var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    className: "undefined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .c{\n    fill:#646464;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1C14 1 14 1 14 1L14 1 14 5C14 5 15 5 15 5L17 8C17 8 17 8 17 8L14 11 14 17C14 17 14 17 14 17L14 18 1 18C1 18 1 17 1 17L1 17 1 1C1 1 1 1 1 1L1 1 14 1ZM13 2L2 2 2 17 13 17 13 12 11 14C11 14 11 14 11 14L8 14C8 14 8 14 8 14L8 12C8 12 8 11 8 11L13 6 13 2ZM14 7L9 12 9 13 10 13 16 8 14 7ZM6 7C6 7 7 7 7 7 7 7 6 8 6 8L6 8 4 8C3 8 3 7 3 7 3 7 3 7 4 7L4 7ZM4 4L11 4C11 4 11 4 11 5 11 5 11 5 11 5L11 5 4 5C3 5 3 5 3 5 3 4 3 4 4 4L4 4 11 4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotes);
export default __webpack_public_path__ + "static/media/icNotes.3160f676627b3e0dd81dfe5663f276eb.svg";
export { ForwardRef as ReactComponent };